exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-enter-active,.view-leave-active{transition:all .4s}.view-enter-active{transition-delay:1s}.view-enter,.view-leave-to{opacity:0;transform:rotateY(90deg)}.view-enter-to,.view-leave{opacity:1;transform:rotateY(0deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a65e047","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 36
// module chunks = 0